import { Icons } from "../../utils";
import "../../styles/common/components.css";

export default function NavControls({ label, onPrev, onNext }) {
  return (
    <div className="nav-controls">
      <button className="nav-button" onClick={onPrev}>
        <Icons.ChevronLeft />
      </button>

      <span className="nav-label">{label}</span>

      <button className="nav-button" onClick={onNext}>
        <Icons.ChevronRight />
      </button>
    </div>
  );
}
